import SectionHeading from "../common/SectionHeading";
import { StaggerGroup } from "../common/Reveal";
import ServiceCard from "../cards/ServiceCard";
import { useContent } from "../../context/ContentContext";

export default function ServicesSection() {
  const { services } = useContent();
  return (
    <section className="relative px-6 py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Technology & Talent Solutions"
          title="End-to-end capability, from strategy to specialized talent"
          subtitle="Six connected practice areas that help you build, modernize and scale — with the right people alongside the right technology."
          testId="services"
        />

        <StaggerGroup className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-12" stagger={0.08}>
          {services.map((s) => (
            <ServiceCard key={s.slug} service={s} />
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
